<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      useManualAppId: false,
      appId: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
    isManualAppIdEnabled() {
      const accountId = this.$route.params.accountId;
      return this.$store.getters['accounts/isFeatureEnabledonAccount'](
        accountId,
        FEATURE_FLAGS.GUPSHUP_MANUAL_APP_ID
      );
    },
  },
  validations() {
    return {
      inboxName: { required },
      appId: this.useManualAppId ? { required } : {},
    };
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const channelPayload = {
          type: 'gupshup',
        };

        if (this.isManualAppIdEnabled && this.useManualAppId && this.appId) {
          channelPayload.app_id = this.appId;
        }

        const gupshupChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            channel: {
              ...channelPayload,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_gupshup_onboarding',
          params: {
            inbox_id: gupshupChannel.id,
          },
        });
      } catch (error) {
        if (error?.response?.data?.gupshup_feature_disabled) {
          router.replace({
            name: 'settings_inbox_list',
            params: { accountId: this.$route.params.accountId },
          });
          return;
        }
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div v-if="isManualAppIdEnabled" class="flex-shrink-0 flex-grow-0 mt-4">
      <label class="flex items-center gap-2">
        <input
          id="useManualAppId"
          v-model="useManualAppId"
          type="checkbox"
        />
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.GUPSHUP.MANUAL_APP_ID.LABEL') }}
        </span>
      </label>
      <p class="text-sm text-n-slate-11 mt-1">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.GUPSHUP.MANUAL_APP_ID.DESCRIPTION') }}
      </p>
    </div>

    <div
      v-if="useManualAppId"
      class="flex-shrink-0 flex-grow-0 mt-4"
    >
      <label :class="{ error: v$.appId.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.GUPSHUP.APP_ID.LABEL') }}
        <input
          v-model="appId"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.GUPSHUP.APP_ID.PLACEHOLDER')"
          @blur="v$.appId.$touch"
        />
        <span v-if="v$.appId.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.GUPSHUP.APP_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.GUPSHUP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

